// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadFormPopup_wrapper__qhfrf","decoration":"LoadFormPopup_decoration__5+GYo"};